import { CardPayment } from "../CardPayment";
import { CashPayment } from "../CashPayment";
import { TransferPayment } from "../TransferPayment";
import { PRPayment } from "../PRPayment";
import { CreditPayment } from "../CreditPayment";
import { SplitPayment } from "../SplitPayment";
import { StoreWalletPayment } from "../StoreWalletPayment";
import { ExclamationCirlce } from "../../../../../assets/svgIcons";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useCheckoutHelper } from "../../../../../hooks/useCheckoutHelper";

export const PaymentsGroup = () => {
  const { payment } = useCheckoutHelper();
  const paymentMethod = payment?.payment_method;

  return (
    <>
      {paymentMethod === "card" && <CardPayment />}
      {paymentMethod === "cash" && <CashPayment />}
      {paymentMethod === "transfer" && <TransferPayment />}
      {paymentMethod === "pr" && <PRPayment />}
      {paymentMethod === "credit" && <CreditPayment />}
      {paymentMethod === "split" && <SplitPayment />}
      {paymentMethod === "store_wallet" && <StoreWalletPayment />}
      {!paymentMethod && (
        <div
          className={`${globalStyles.cardWithBackground} text-center`}
          style={{ background: "#FFDDD2" }}
        >
          <h6
            className="error--text small-text-size d-flex mx-auto align-items-center"
            style={{ gap: "5px" }}
          >
            <ExclamationCirlce stroke="black" width="22" height="22" />
            <span>ATTENTION</span>
          </h6>
          <p className="dark--text small-text-size">
            Please select a payment method before completing this order
          </p>
        </div>
      )}
    </>
  );
};
